import { ConditionType } from "src/types/visual";

type FilterRoot = { conditions?: unknown[] } | null | undefined;

export function collectAudienceIds(root: FilterRoot): string[] {
  if (!root) return [];
  const ids = new Set<string>();
  const stack: unknown[] = Array.isArray(root.conditions)
    ? [...root.conditions]
    : [];
  while (stack.length > 0) {
    const c = stack.pop();
    if (!c || typeof c !== "object") continue;
    const node = c as Record<string, unknown>;
    if (node.type === ConditionType.SegmentSet) {
      if (node.modelId !== undefined && node.modelId !== null) {
        ids.add(String(node.modelId));
      }
    }
    if (Array.isArray(node.conditions)) {
      for (const child of node.conditions) stack.push(child);
    }
  }
  return Array.from(ids);
}
